import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import HomePage from './pages/HomePage.vue'
import QuizzPrepPage from './pages/QuizzPrepPage.vue'
import QuizzPage from './pages/QuizzPage.vue'
import LearnPage from './pages/LearnPage.vue'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
})

const routes = [
    { path: '/', component: HomePage },
    { path: '/quizz', component: QuizzPrepPage },
    { path: '/quizz/:nombreDeQuestions/:isRandom', component: QuizzPage },
    { path: '/apprendre', component: LearnPage },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
})

createApp(App).use(router).use(vuetify).mount('#app')